<template>
  <transition mode="out-in">
    <router-view class="main-container">
    </router-view>
  </transition>
</template>
<script>
  'use strict'
  import eventBus from './utils/eventBus'
  import utils from './utils/utils'
  export default {
    data() {
      return {
        transitionName: ''
      }
    },
    watch: {
      $route(to, from) {
        let toDepth = to.path.split('/').length
        let fromDepth = from.path.split('/').length
        if (to.fullPath !== '/') {
          this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
        }
      }
    },
    mounted () {
      if (utils.getBrowser().isAndroidApp) {
        let cssTag = document.getElementById('loadCss')
        let head = document.getElementsByTagName('head').item(0)
        if (cssTag) {
          head.removeChild(cssTag)
        }
        let css = document.createElement('link')
        css.href = '/static/font/font.css'
        css.rel = 'stylesheet'
        css.type = 'text/css'
        css.id = 'loadCss'
        head.appendChild(css)
      }
      eventBus.$on('router-push', (url) => {
        this.$router.push(url)
      })
    }
  }
</script>
<style lang="less">
  /*@import '~vux/src/styles/reset.less';*/
  .main-container {
    transition: all 0.5s ease;
    position: absolute;
    width: 100%;
    // min-height: 100%;
    height: 100%;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
  }

  .slide-left-enter,
  .slide-right-leave-active {
    -webkit-transform: translate(100%);
  }
  .slide-left-leave-active,
  .slide-right-enter {
    transform: translate(-100%);
  }
</style>
